<template>
  <div>
    <div :class="`print__logo ${hideOnPrint ? 'd-none' : ''}`">
      <img class="print__logo-symbol" :src="symbol" />
      <img class="print__logo-type" :src="logo" />
    </div>
    <v-row
      class="header"
      :class="{
        'mb-1': $vuetify.breakpoint.mobile,
        'mb-5': !$vuetify.breakpoint.mobile,
      }"
      no-gutters
    >
      <v-col :class="hideOnPrint ? 'hide-on-print' : ''" cols="12" sm="8">
        <div class="d-flex align-center">
          <v-btn
            v-if="
              $vuetify.breakpoint.xsOnly &&
              !noSidebarInThisRoutes.includes($route.name)
            "
            @click="toggleDrawerMenu"
            class="mr-2"
            icon
          >
            <v-icon>mdi-menu</v-icon>
          </v-btn>

          <v-btn @click="$router.push(`${back}`)" class="mr-2" icon v-if="back">
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>

          <h2 class="title__principal mr-2">
            {{ customTitle ? customTitle : title }}
          </h2>

          <slot name="changes" />
        </div>
      </v-col>
      <v-col class="text-right header__actions" cols="12" sm="4">
        <slot name="actions" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import { noSidebarInThisRoutes } from '@/util/helpers'

import logo from '@/assets/images/logo-hauseful-type-dark.svg'
import symbol from '@/assets/images/logo-hauseful-symbol-dark.svg'

export default {
  name: 'Header',

  props: {
    back: {
      type: String,
      default: '',
    },

    customTitle: {
      type: String,
      default: '',
    },
  },

  computed: {
    ...mapGetters(['isMenuDrawerOpen']),

    hideOnPrint() {
      if (this.$route.name === 'quote') return true
      if (this.$route.name === 'appointmentsDetails') return true
      return false
    }
  },

  methods: {
    ...mapMutations(['setIsMenuDrawerOpen']),

    toggleDrawerMenu() {
      this.setIsMenuDrawerOpen(!this.isMenuDrawerOpen)
    },
  },

  data() {
    return {
      title: this.$route?.meta ? this.$route?.meta?.title : '',
      noSidebarInThisRoutes,
      symbol,
      logo,
    }
  },
}
</script>

<style scoped>
@media print {
  .hide-on-print {
    display: none;
  }
}
</style>
